import { TEST_IDS } from '@va/constants';
import { RightArrowIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { DataViewOption } from '@va/types/report-block';
import { Checkmark } from '@va/util/components';
import { useFocusedActions } from '@va/util/hooks';
import { useMemo, useRef } from 'react';
import { Paragraph, fontWeights } from '../typography';
import { getViewIcon } from './utils';

export const ViewListItem = ({
  isSelected,
  onClick,
  view,
  hasSubOptions = false,
}: {
  isSelected: boolean;
  onClick: () => void;
  view: DataViewOption;
  hasSubOptions?: boolean;
}) => {
  const ref = useRef<HTMLLIElement>(null);
  const Icon = useMemo(() => getViewIcon(view), [view]);
  const translate = useTranslate();

  useFocusedActions({ ref, onAction: onClick });

  return (
    <li
      ref={ref}
      data-testid={TEST_IDS.helpers.createListItemId(`visualization-option-${view}`)}
      onClick={onClick}
      className='flex items-center gap-3 p-3 rounded-12 hover:bg-white-snow active:bg-gray-concrete cursor-pointer'
      tabIndex={0}
    >
      {<Icon color='#696969' />}
      <Paragraph weight={fontWeights.medium}>{translate(`all.dataViewOptions.${view}`)}</Paragraph>
      <div className='ml-auto'>
        {hasSubOptions ? <RightArrowIcon color='#969696' className='h-6 w-6' /> : <Checkmark selected={isSelected} />}
      </div>
    </li>
  );
};
